import { useState } from "react";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    addslashes,
    myAxios,
    MyFormData
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function AsyncFilter({
    setCurrentPage, 
    setFilter, 
    setActiveFilter, 
    curFilter, 
    activeFilter, 
    defaultFilter, 
    width, 
    url, 
    dataFrame, 
    setItems, 
}){
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [showFilter, setShowFilterForm] = useState(false);
    //--------------------------------------------------------------------------------------------
    return (
        <>
        <button
            type = "button"
            className = "headerButton"
            style = {{
                backgroundColor: Object.entries(curFilter).find(([key, value]) => defaultFilter[key] !== value)?
                "rgb(0,123,255)"
                :null
            }}
            onClick = {() => {setShowFilterForm(true)}}
        >
            Filter
        </button>
        {showFilter?
        <Modal
            closeIt = {() => {
                setShowFilterForm(false);
                setFilter(activeFilter);
            }}
            title = "Filter"
            width = {width}
            actionKey = "Confirm"
            handleFormSubmit = {async() => {
                setActiveFilter(curFilter);
                // const arr = [];
                // for(const key in curFilter){
                //     if(curFilter[key]){
                //         arr.push(`INSTR(\`${key}\`, "${addslashes(curFilter[key])}")`);
                //     }
                // }
                // const formData = new MyFormData();
                // formData.append("search", arr.length?"WHERE " + arr.join(" AND "):"");
                const searchArray = [];
                for(const key in curFilter){
                    if(curFilter[key]){
                        searchArray.push({ key, value: curFilter[key] });
                    }
                }
                const formData = new MyFormData();
                formData.append("search", JSON.stringify(searchArray));
                //-------------------------
                setShowLoader(true);
                const res = await myAxios(url, formData);
                setShowLoader(false);
                if(!res) return;
                //-------------------------
                setItems(res.data);
                setShowFilterForm(false);
            }}
        >
            <div className = "mt-2 mb-2">
                <button
                    type = "button"
                    className = "btn btn-secondary"
                    onClick = {() => {
                        setFilter(defaultFilter);
                        setCurrentPage(1);
                    }}
                >Clear Filter</button>
            </div>
            {dataFrame.map((item, itemKey) => 
            item.type === "phone"?
            <div key = {itemKey} className = "d-flex align-items-center mb-2">
                <label htmlFor = {item.key} className = "font-weight-bold mb-0">{item.label}:</label>
                <Cleave
                    id = {item.key}
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                    className = "form-control flex-grow-1 ml-3"
                    
                    value = {curFilter[item.key]}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key]: e.currentTarget.value.toLocaleLowerCase()});
                        setCurrentPage(1);
                    }}
                    options = {{ 
                        blocks:[3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                />
                {
                curFilter[item.key] !== ""?
                <button type = "button" className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key]: ""})}}>❌</button>:
                null
                }
            </div>
            :item.type === "select"?
            <div className = "mb-2 d-flex align-items-center">
                <label htmlFor = {item.key} className = "font-weight-bold mb-0">{item.label}:</label>
                <select
                    id = {item.key}
                    type = "text"
                    className = "form-control w-auto flex-grow-1 ml-3"
                    value = {curFilter[item.key]}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key]: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {item.options.map((opt, optIndex) => <option key = {optIndex} value = {opt.value}>{opt.label}</option>)}
                </select>
                {
                curFilter[item.key] !== ""?
                <button type = "button" className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key]: ""})}}>❌</button>:
                null
                }
            </div>
            :
            <div key = {itemKey} className = "d-flex align-items-center mb-2">
                <label htmlFor = {item.key} className = "font-weight-bold mb-0">{item.label}:</label>
                <input
                    autoComplete = {item.autoComplete ?? "off"}
                    id = {item.key}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[item.key]}
                    onChange = {e => {
                        setFilter({...curFilter, [item.key]: e.currentTarget.value.toLocaleLowerCase()});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter[item.key] !== ""?
                <button type = "button" className = "noButtonStyle ml-2" onClick = {() => {setFilter({...curFilter, [item.key]: ""})}}>❌</button>:
                null
                }
            </div>)}
            <div className = "mt-2 mb-2">
                <button
                    type = "button"
                    className = "btn btn-secondary"
                    onClick = {() => {
                        setFilter(defaultFilter);
                        setCurrentPage(1);
                    }}
                >Clear Filter</button>
            </div>
        </Modal>
        :null}
        </>
    )
}